var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:{'on' : _vm.val},on:{"click":function($event){return _vm.$emit('update:val', !_vm.val)}}},[_c('span',{staticClass:"button"})])
}
var staticRenderFns = []

export { render, staticRenderFns }